import React, { useEffect } from 'react';
import { Row, Col } from 'shards-react';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { SmartTable } from '../../components/common';
import { getRoles } from '../../store/actions/roles';
import { MainStage } from '../../components/layout';

const RoleListing = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const rolesData = useSelector(({ roles: { roles } }) => roles);

  const columns = [
    {
      header: 'Name',
      accessor: 'name',
      width: '20%',
      cell: (row, data) => <Link to={`/roles/${data.id}`}>{row.value}</Link>,
    },
    {
      header: 'Assigned',
      accessor: 'count',
    },
    {
      header: 'Created By',
      accessor: 'audit.createdBy',
    },
    {
      header: 'Created On',
      accessor: 'audit.createdOn',
      cell: ({ value }) => moment(value.toDate()).format('lll'),
    },
    {
      header: 'Updated By',
      accessor: 'audit.updatedBy',
    },
    {
      header: 'Updated On',
      accessor: 'audit.updatedOn',
      cell: ({ value }) => (value ? moment(value.toDate()).format('lll') : ''),
    },
  ];

  useEffect(() => {
    if (rolesData.length === 0) {
      dispatch(getRoles());
    }
    // eslint-disable-next-line
  }, []);

  return (
    <MainStage title="Overview" subtitle="Roles">
      <Row>
        <Col>
          <SmartTable
            title="Active Roles"
            data={rolesData}
            columns={columns}
            onCreate={() => history.push('/roles/new')}
          />
        </Col>
      </Row>
    </MainStage>
  );
};

export default RoleListing;
